(function () {
  var subject = document.querySelector('[data-subject]');
  var conditionals = document.querySelectorAll('.tpl-cf__conditional');
  var nameRow = document.getElementById('cf-row-name');
  var form = document.getElementById('ContactForm');
  var messageLabel = document.getElementById('cf-message-label');

  if (!subject || !form) return;

  // ── Budget dropdown: populate based on visitor timezone ──
  var budgetEl = form.querySelector('[data-budget]');
  if (budgetEl) {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    var isIndia = tz.indexOf('Kolkata') !== -1 || tz.indexOf('Calcutta') !== -1;
    var opts = isIndia
      ? [
          ['Under ₹1L', 'Under ₹1,00,000'],
          ['₹1L–₹5L', '₹1,00,000 – ₹5,00,000'],
          ['₹5L–₹10L', '₹5,00,000 – ₹10,00,000'],
          ['₹10L+', '₹10,00,000+']
        ]
      : [
          ['Under $1,000', 'Under $1,000'],
          ['$1,000–$5,000', '$1,000 – $5,000'],
          ['$5,000–$10,000', '$5,000 – $10,000'],
          ['$10,000+', '$10,000+']
        ];
    var prefer = budgetEl.querySelector('option[value="Prefer not to say"]');
    opts.forEach(function (o) {
      var opt = document.createElement('option');
      opt.value = o[0];
      opt.textContent = o[1];
      budgetEl.insertBefore(opt, prefer);
    });
  }

  // ── Subject-based field visibility ──
  var placeholders = {
    'general-inquiry': '',
    'artist-submission': 'Medium, themes, what draws you to print...',
    'b2b-commission': 'Scale, timeline, space type, any references...'
  };

  var labels = {
    'general-inquiry': 'Message',
    'artist-submission': 'Tell us about your work',
    'b2b-commission': 'Tell us about the project'
  };

  var buttonLabels = {
    'general-inquiry': 'Send Message',
    'artist-submission': 'Send Submission',
    'b2b-commission': 'Send Enquiry'
  };

  function updateFields() {
    var val = subject.value;

    conditionals.forEach(function (el) {
      var showFor = el.getAttribute('data-show-for');
      var visible = showFor === val;
      el.classList.toggle('is-visible', visible);
      // Disable hidden inputs so they don't submit
      el.querySelectorAll('input, select, textarea').forEach(function (inp) {
        inp.disabled = !visible;
      });
    });

    // Name row: show as grid when B2B (company field visible)
    if (nameRow) {
      nameRow.classList.toggle('is-grid', val === 'b2b-commission');
    }

    // Update message label + placeholder
    var textarea = document.getElementById('cf-message');
    if (textarea && placeholders[val] !== undefined) {
      textarea.placeholder = placeholders[val];
    }
    if (messageLabel && labels[val]) {
      messageLabel.textContent = labels[val];
    }

    // Update submit button text
    var btn = form.querySelector('.tpl-cf__submit');
    if (btn && buttonLabels[val]) {
      btn.textContent = buttonLabels[val];
    }
  }

  subject.addEventListener('change', updateFields);

  /* 2026-09-06: footer links arrive as /pages/contact?type=<subject value>.
     Preselect the matching subject so the right fields are already open. */
  try {
    var wanted = new URLSearchParams(window.location.search).get('type');
    if (wanted && subject.querySelector('option[value="' + wanted.replace(/"/g, '') + '"]')) {
      subject.value = wanted;
      updateFields();
    }
  } catch (e) {
    /* URLSearchParams unsupported: leave the default state */
  }
  updateFields(); // Run on load

  /* TPL patch 2026-07-10 (audit P1-9): footer deep-links carry intent hashes
     (#artist, #b2b, #general, #generalContact) but the page had no matching
     anchors, so every routed link just landed at the top. Map the hash to the
     subject select, run the dependent-field logic, and scroll to the form. */
  var HASH_TO_SUBJECT = {
    general: 'general-inquiry',
    generalcontact: 'general-inquiry',
    artist: 'artist-submission',
    b2b: 'b2b-commission',
  };
  function applyIntentHash() {
    var key = (window.location.hash || '').replace('#', '').toLowerCase();
    var value = HASH_TO_SUBJECT[key];
    if (!value) return;
    subject.value = value;
    updateFields();
    var formEl = subject.closest('form') || subject;
    formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  applyIntentHash();
  window.addEventListener('hashchange', applyIntentHash);

  // ── Custom validation ──
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function getFieldEl(input) {
    return input.closest('.tpl-cf__field');
  }

  function setError(input, message) {
    var field = getFieldEl(input);
    if (!field) return;
    field.classList.add('tpl-cf__field--invalid');
    var errEl = field.querySelector('.tpl-cf__field-error');
    if (errEl) errEl.textContent = message;
  }

  function clearError(input) {
    var field = getFieldEl(input);
    if (!field) return;
    field.classList.remove('tpl-cf__field--invalid');
    var errEl = field.querySelector('.tpl-cf__field-error');
    if (errEl) errEl.textContent = '';
  }

  function validateForm() {
    var valid = true;
    var firstInvalid = null;

    // Clear all errors first
    form.querySelectorAll('.tpl-cf__field--invalid').forEach(function (f) {
      f.classList.remove('tpl-cf__field--invalid');
      var errEl = f.querySelector('.tpl-cf__field-error');
      if (errEl) errEl.textContent = '';
    });

    // Validate subject
    if (!subject.value) {
      setError(subject, 'Please select a subject.');
      if (!firstInvalid) firstInvalid = subject;
      valid = false;
    }

    // Validate required inputs/textareas (skip disabled ones — hidden conditional fields)
    form.querySelectorAll('input[required]:not(:disabled), textarea[required]:not(:disabled)').forEach(function (el) {
      if (el.type === 'email') {
        if (!el.value.trim()) {
          setError(el, 'Email address is required.');
          if (!firstInvalid) firstInvalid = el;
          valid = false;
        } else if (!EMAIL_RE.test(el.value.trim())) {
          setError(el, 'Please enter a valid email address.');
          if (!firstInvalid) firstInvalid = el;
          valid = false;
        }
      } else {
        if (!el.value.trim()) {
          var label = getFieldEl(el) && getFieldEl(el).querySelector('.tpl-cf__label');
          var fieldName = label ? label.textContent.trim().replace(/\(optional\)/i, '').trim() : 'This field';
          setError(el, fieldName + ' is required.');
          if (!firstInvalid) firstInvalid = el;
          valid = false;
        }
      }
    });

    if (firstInvalid) firstInvalid.focus();
    return valid;
  }

  // ── Submit handler ──
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (validateForm()) {
      var btn = form.querySelector('.tpl-cf__submit');
      var originalText = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Sending…';
      }
      setTimeout(function () {
        if (btn && btn.disabled) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
      }, 8000);
      form.submit();
    }
  });

  // Clear errors on input
  form.querySelectorAll('.tpl-cf__input').forEach(function (input) {
    input.addEventListener('input', function () { clearError(input); });
    input.addEventListener('change', function () { clearError(input); });
  });

})();
